import { useState } from 'react';

import { StepItem, StepList } from './step-list';
import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/new/components/shadcn/dialog';

export const DocumentUploadOnboarding = () => {
  const [isOpen, setIsOpen] = useState(true);

  const steps: StepItem[] = [
    {
      icon: <Icon className="lucide--upload" />,
      title: 'Upload documents',
      description:
        'Add the documents you want to process. Either from your file system, or using our integrations. If you are uploading over 1000 documents we recommend zipping them first.',
    },
    {
      icon: <Icon className="lucide--save" />,
      title: 'Wexler saves your files',
      description:
        "Once your files are uploaded, you can leave this page and come back and your files will still be here. Wexler also automatically deduplicates files so you can't upload the same file twice.",
    },
    {
      icon: <Icon className="lucide--clock" />,
      title: 'Start processing',
      description: 'Click the Process Documents button to begin! This will begin fact extraction on your documents.',
    },
  ];

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-w-3xl" data-testid="document-upload-onboarding-modal">
        <DialogHeader>
          <DialogTitle>
            <Icon className="lucide--upload" />
            Uploading Documents
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-2 text-sm text-gray-600">
          <p>Let's get started by uploading your first documents!</p>
        </div>

        <StepList steps={steps} />

        <p className="text-xs text-gray-700">
          Whilst documents are processing you will need to wait until this processing is complete before uploading more.
        </p>

        <DialogFooter className="justify-center">
          <Button variant="primary" onClick={() => setIsOpen(false)} className="px-6">
            Got it!
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
